import React, { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import FormSection from './components/FormSection';
import { useGetLandingPageQuery } from '../../redux/api/content.api';
import Page404 from '../../containers/page404';
import Loader from '../../components/common/loader';
import HeaderGallery from '../customer-join/sections/HeaderGallery';
import DynamicStripSection from './components/DynamicStripSection'
import InterestsCategoriesSection from './components/InterestsCategoriesSection';
import ContactUsComponent from './components/ContactUsComponent';
import SocialLinksSection from './components/SocialLinksSection';
import TopInfoCardComponent from './components/TopInfoCardComponent';

const BUFFER_PIXELS = 0; // Buffer zone to show button earlier

const LandingPage = ({ match }) => {
    const {slug} = match.params;
    const { data: landingPageData, isLoading, error } = useGetLandingPageQuery({slug});
    const [formPosition, setFormPosition] = useState({ above: false, below: true });
    const [afterFormPosition, setAfterFormPosition] = useState({ above: false, below: true });
    const formSectionRef = useRef(null);
    const afterFormRef = useRef(null);
  
  
    useEffect(() => {
      const formObserver = new IntersectionObserver(
        ([entry]) => {
          const bounds = entry.boundingClientRect;
          const windowHeight = window.innerHeight;
          
          setFormPosition({
            above: bounds.bottom < -BUFFER_PIXELS, // Add buffer for earlier appearance when scrolling up
            below: bounds.top > (windowHeight + BUFFER_PIXELS) // Add buffer for earlier appearance when scrolling down
          });
        },
        {
          threshold: [0, 1]
        }
      );
  
      const afterFormObserver = new IntersectionObserver(
        ([entry]) => {
          const bounds = entry.boundingClientRect;
          const windowHeight = window.innerHeight;
  
          setAfterFormPosition({
            above: bounds.bottom < -BUFFER_PIXELS, // Add buffer for earlier appearance when scrolling up
            below: bounds.top > (windowHeight + BUFFER_PIXELS) // Add buffer for earlier appearance when scrolling down
          });
        },
        {
          threshold: [0, 1]
        }
      );
  
      if (formSectionRef.current) {
        formObserver.observe(formSectionRef.current);
      }
      if (afterFormRef.current) {
        afterFormObserver.observe(afterFormRef.current);
      }
  
      return () => {
        if (formSectionRef.current) {
          formObserver.unobserve(formSectionRef.current);
        }
        if (afterFormRef.current) {
          afterFormObserver.unobserve(afterFormRef.current);
        }
      };
    }, []);
  
  
  
    if (isLoading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
          <Loader />
        </Box>
      );
    }
    if( (error || landingPageData.error )&& slug) {
      // TODO: redirect to customer join page
       return (
        <Page404 />
      );     
     }
  
    if (error) {
      return (
        <Page404 />
      );
    }
  
    if (!landingPageData) {
      return null;
    }
  
    return (
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: '#FFFFFF',
          maxWidth: '100%',
        }}
        testID="landing-page"
      > 
        <HeaderGallery data={landingPageData.galleryHeaderSection} testID="header-gallery-section" aspectRatioDesktop={2560/500} />
        <TopInfoCardComponent data={landingPageData.topInfoCardsSection} testID="top-info-card-section" /> 
        <DynamicStripSection dynamicText={landingPageData.dynamicStripSection.dynamicText} dynamicTextImage={landingPageData.dynamicStripSection.dynamicTextImage} />
        <div ref={formSectionRef} id="form-section" testid="form-section"/>
        <FormSection data={landingPageData.formSection} testID="form-section-component" />
        <div  ref={afterFormRef} testid="after-form-section"/>
        <SocialLinksSection data={landingPageData.appAndSocialLinksSection} />
        <InterestsCategoriesSection data={landingPageData.interestsCategoriesSection} />
        <ContactUsComponent data={landingPageData.contactUsSection} />  
      </Box>
    );
};

export default LandingPage;
